// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sLK-","inner":"Footer_inner__255bt","nextIcon":"Footer_nextIcon__2q6-Q","innerLeft":"Footer_innerLeft__bMHMJ"};